import {hoistCmp} from '@xh/hoist/core';
import {WorkingOrdersModel} from './WorkingOrdersModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {hframe, vframe} from '@xh/hoist/cmp/layout';
import './WorkingOrders.scss';
import {textInput} from '@xh/hoist/desktop/cmp/input';
import {listCheckIcon} from '../../../../../core/Icons';
import {configurableGrid} from '../../../../cmp/gridSpec/ConfigurableGrid';

export const workingOrdersPanel = hoistCmp.factory<WorkingOrdersModel>(({model}) =>
    panel({
        model: model.ordersPanelModel,
        className: 'working-orders',
        compactHeader: true,
        title: 'Working Orders',
        icon: Icon.gear({intent: 'primary'}),
        headerItems: [
            textInput({
                bind: 'filterText',
                placeholder: 'Filter by ticker',
                commitOnChange: true,
                enableClear: true,
                leftIcon: Icon.search(),
                width: 200
            }),
            button({
                icon: Icon.gear(),
                tooltip: 'Configure the order grids (with AI assistant)',
                onClick: () => model.configurableGridModel.openConfigurator()
            }),
            button({
                icon: Icon.eye(),
                title: 'Show/Hide Filled',
                active: !model.completedOrdersPanelModel.collapsed,
                onClick: () => model.toggleCompleted()
            }),
            button({
                icon: Icon.pin(),
                title: 'Always show fills',
                active: model.alswaysShowFills,
                onClick: () => model.toggleAlwaysShowFills()
            })
        ],
        item: ordersPanel()
    })
);

// Both order grids follow one spec - while configuring, the two of them go modal with the configurator
const ordersPanel = hoistCmp.factory<WorkingOrdersModel>(({model}) =>
    hframe(
        configurableGrid({
            model: model.configurableGridModel,
            item: vframe(
                panel({
                    item: grid({model: model.workingOrdersModel, testId: 'working-orders-grid'})
                }),
                panel({
                    model: model.completedOrdersPanelModel,
                    compactHeader: true,
                    title: 'Filled Orders',
                    icon: Icon.check({intent: 'success'}),
                    item: grid({model: model.completedOrdersModel, testId: 'completed-orders-grid'})
                })
            )
        }),
        panel({
            model: model.fillsPanelModel,
            compactHeader: true,
            title: 'Fills',
            icon: listCheckIcon(),
            item: grid({model: model.fillsModel, testId: 'fills-grid'})
        })
    )
);
